import { Card } from 'antd'
import Flex from 'components/Flex'

import styled from 'styled-components'
import { COLORS } from 'theme'

export const EvaluationCardDiv = styled.div`
  overflow-y: hidden;
  overflow: scroll;
`

export const EvaluationCard = styled(Card)`
  width: 600px;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 0 3px 3px 3px;
  margin: 10px;
  background: linear-gradient(0deg, #ffffff, #ffffff),
    linear-gradient(0deg, #e6e7ea, #e6e7ea);
  overflow: auto;
  overflow-y: hidden;
`

export const HeaderCard = styled.div`
  display: flex;
  place-content: space-between;
  padding-bottom: 10px;
  margin-top: -15px;
`
export const RightFlex = styled.div`
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  white-space: nowrap;
`

export const ExtraFlex = styled.div`
  border-right: 1px solid ${COLORS.GREY_T_90};
  border-right-width: 1px;
`

export const HeaderFlex = styled(Flex)`
  border-bottom: 1px solid #e6e7ea;
  box-shadow: 0px 2px 1px 0px #9999991a;
  padding-bottom: 30px;
  margin-bottom: 20px;
`
export const HeaderFlexATS = styled(Flex)`
  gap: 40px;
  margin-bottom: 20px;
`

export const TabDiv = styled(Flex)`
  border-bottom: 1px solid #e6e7ea;
  box-shadow: 0px 2px 1px 0px #9999991a;
`
export const ExtraPadding = styled.div`
  padding-bottom: 10px;
`
export const ExtraLeftPadding = styled.div`
  padding-left: 60px;
`
